import React, { useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import { addEventNameToEndpoint } from '../../utils/common';

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <div className="d-flex align-items-center">
      <FontAwesomeIcon icon={faBookmark} rotation={270} className="mr-1" color={props.data.color} />{props.value}
      {children}
    </div>
  </components.SingleValue>
);

const Option = props => (
  <components.Option {...props}>
    <div className="d-flex align-items-center m-1">
      <FontAwesomeIcon icon={faBookmark} rotation={270} className="mr-1" color={props.data.color} />
      <span className="ml-2" style={{ color: 'black' }}>{props.label}</span>
    </div>
  </components.Option>
);

const TagsEditor = props => {
  const [value, setValue] = useState(null);

  // thanks https://gist.github.com/mjackson/5311256
  const hsvToRgb = (h, s, v) => {
    let r, g, b;

    let i = Math.floor(h * 6);
    let f = h * 6 - i;
    let p = v * (1 - s);
    let q = v * (1 - f * s);
    let t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0: r = v; g = t; b = p; break;
      case 1: r = q; g = v; b = p; break;
      case 2: r = p; g = v; b = t; break;
      case 3: r = p; g = q; b = v; break;
      case 4: r = t; g = p; b = v; break;
      case 5: r = v; g = p; b = q; break;
      default: break;
    }

    return [ Math.round(r * 255), Math.round(g * 255), Math.round(b * 255) ];
  };

  const rgbToHex = (rgbArray) => '#' + rgbArray.map(x => {
    const hex = x.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }).join('');

  // based on golden ratio
  // https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
  const buildNewTagColor = () => {
    const goldenRatioConjugate = 0.618033988749895;
    let h = Math.random();
    h += goldenRatioConjugate;
    h %= 1;
    const tagColor = rgbToHex(hsvToRgb(h, 0.5, 0.95));
    return tagColor;
  }

  const handleChange = (value, e) => {
    const userId = _.get(props, "cognitoUser.username", '');

    if (e.action === 'create-option') {
      addEventNameToEndpoint(props.Analytics, 'user-tag-add');

      props.Analytics.record({ name: 'user-tag-add', attributes: { contentTagName: props.value } });

      props.addContentTagSuccess({
        key: value.value,
        color: buildNewTagColor(),
        sort: 101
      });

      if (props.onChange) {
        props.onChange({
          key: value.value,
          color: buildNewTagColor(),
          sort: 101,
          createdBy: userId
        });
      }
    } else {
      if (props.onChange) {
        const { contentTags } = props;

        props.onChange({
          key: value.value,
          color: contentTags[value.value].color,
          sort: contentTags[value.value].sort,
          createdBy: userId
        });
      }
    }
  }

  const { contentTags } = props;
  const options = Object.keys(props.contentTags)
    .filter(key => !Object.keys(props.selectedTags).includes(key))
    .map(key => ({
      value: key,
      label: key,
      color: contentTags[key].color
    }));


  return (
    <div>
      <CreatableSelect
        className={props.className}
        options={options}
        onChange={handleChange}
        components={{ Option, SingleValue }}
        placeholder="+ Add tag"
        isDisabled={props.disabled}
        value={value}
        tabIndex={0}
      />
    </div>
  )
}

export default TagsEditor;
